import { render, staticRenderFns } from "./_userAvatar.vue?vue&type=template&id=2b812f22&scoped=true"
import script from "./_userAvatar.vue?vue&type=script&lang=js"
export * from "./_userAvatar.vue?vue&type=script&lang=js"
import style0 from "./_userAvatar.vue?vue&type=style&index=0&id=2b812f22&prod&scoped=true&lang=css"
import style1 from "./_userAvatar.vue?vue&type=style&index=1&id=2b812f22&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b812f22",
  null
  
)

export default component.exports